var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 62,
    viewBox: "0 0 135 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_8154)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1367_8154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5935 31.666C61.5935 35.279 58.6917 37.9414 55.1309 37.9414C51.5697 37.9414 48.668 35.279 48.668 31.666C48.668 28.0275 51.5697 25.3906 55.1309 25.3906C58.6917 25.3906 61.5935 28.0275 61.5935 31.666ZM58.7643 31.666C58.7643 29.4083 57.0827 27.8634 55.1309 27.8634C53.1788 27.8634 51.4972 29.4083 51.4972 31.666C51.4972 33.9012 53.1788 35.4686 55.1309 35.4686C57.0827 35.4686 58.7643 33.8984 58.7643 31.666Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5349 31.666C75.5349 35.279 72.6332 37.9414 69.0721 37.9414C65.5112 37.9414 62.6094 35.279 62.6094 31.666C62.6094 28.0303 65.5112 25.3906 69.0721 25.3906C72.6332 25.3906 75.5349 28.0275 75.5349 31.666ZM72.7058 31.666C72.7058 29.4083 71.0241 27.8634 69.0721 27.8634C67.1202 27.8634 65.4386 29.4083 65.4386 31.666C65.4386 33.9012 67.1202 35.4686 69.0721 35.4686C71.0241 35.4686 72.7058 33.8984 72.7058 31.666Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8971 25.7697V37.0361C88.8971 41.6705 86.0913 43.5632 82.7742 43.5632C79.6518 43.5632 77.7726 41.5289 77.0638 39.8653L79.5269 38.8667C79.9656 39.888 81.0403 41.0933 82.7714 41.0933C84.8946 41.0933 86.2104 39.8173 86.2104 37.4152V36.5126H86.1117C85.4783 37.2737 84.2586 37.9387 82.7191 37.9387C79.498 37.9387 76.5469 35.2055 76.5469 31.6887C76.5469 28.1463 79.498 25.3906 82.7191 25.3906C84.2556 25.3906 85.4755 26.0554 86.1117 26.7939H86.2104V25.7726H88.8971V25.7697ZM86.4109 31.6887C86.4109 29.4789 84.8975 27.8634 82.9719 27.8634C81.0198 27.8634 79.3846 29.4789 79.3846 31.6887C79.3846 33.8757 81.0198 35.4686 82.9719 35.4686C84.8975 35.4686 86.4109 33.8757 86.4109 31.6887Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3257 19.166V37.5566H90.5664V19.166H93.3257Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.081 33.7314L106.277 35.1573C105.567 36.1786 103.86 37.9385 100.909 37.9385C97.2492 37.9385 94.5156 35.1828 94.5156 31.6631C94.5156 27.9313 97.2724 25.3877 100.593 25.3877C103.935 25.3877 105.57 27.9793 106.105 29.3799L106.398 30.0928L97.7862 33.5673C98.4456 34.8263 99.4704 35.4685 100.909 35.4685C102.349 35.4685 103.349 34.7781 104.081 33.7314ZM97.3215 31.4735L103.078 29.145C102.762 28.3613 101.809 27.8152 100.688 27.8152C99.2497 27.8152 97.2492 29.0516 97.3215 31.4735Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2238 30.0334V27.371H47.4343C47.5243 27.8351 47.5707 28.3839 47.5707 28.978C47.5707 30.9756 47.0101 33.4456 45.2035 35.2054C43.4462 36.9879 41.201 37.9385 38.2267 37.9385C32.7138 37.9385 28.0781 33.5644 28.0781 28.1944C28.0781 22.8243 32.7138 18.4502 38.2267 18.4502C41.2765 18.4502 43.4491 19.6158 45.0815 21.1352L43.1529 23.0139C41.9823 21.9444 40.3964 21.1125 38.2238 21.1125C34.1981 21.1125 31.0495 24.2729 31.0495 28.1944C31.0495 32.1158 34.1981 35.2761 38.2238 35.2761C40.835 35.2761 42.3221 34.2547 43.2749 33.3267C44.0475 32.5741 44.5558 31.499 44.7562 30.0306L38.2238 30.0334Z",
    fill: "#1F2022"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_8154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 62,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1367_8154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 61.7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo2);
export default __webpack_public_path__ + "static/media/google-logo-2.6b967b77a2b69312f2e295b1af51a668.svg";
export { ForwardRef as ReactComponent };